<template>
  <mescroll-vue :up="getscrollData()" @init="initScroll" :down="mescrollDown">
    <div class="list" id="dataList">
      <div
        v-for="(item, index) in resourceData"
        :key="index"
        @click="toResourceUri(item)"
      >
        <search-cell :msg="item | formatData"></search-cell>
      </div>
    </div>
  </mescroll-vue>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import SearchCell from "./searchCell.vue";
import pub_methods from "./mixins/pub_methods.js";
export default {
  name: "resources",
  mixins: [pub_methods],
  data() {
    return {
      resourceData: [],
      mescroll: null,
    };
  },
  components: {
    SearchCell,
    MescrollVue,
  },
  methods: {
    upCallback(page, mescroll) {
      this.getDatas(page.num, page.size, "", mescroll);
    },
    // 获取数据
    getDatas(pageNum, pageSize, keyword, mescroll) {
      let _this = this;
      let url = "index.php/mobile/search/resources-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: 5,
        language: localStorage.getItem("_user_data_language"),
        size: pageSize,
        page: pageNum,
        keyword: _this.$store.state.searchWord,
        // client_version:'1.2.0'
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          let data = res.data.result.data;
          if (pageNum == 1) {
            _this.resourceData = [];
          }
          _this.resourceData = _this.resourceData.concat(data);
          _this.$nextTick(() => {
            if (pageNum > res.data.result.pages.page_count) {
              mescroll.endSuccess(data.length, false);
            } else {
              mescroll.endSuccess(data.length, true);
            }
          });
        }
      });
    },
    toResourceUri(item) {
      if (item.template_style === "p2p") {
        this.$router.push({
          path: "/P2Pstudy/study_way",
          query: { tid: item.trainplan_id },
        });
      } else {
        this.$router.push({
          path: "/main/plan_stage",
          query: { tid: item.trainplan_id, rid: item.resources_id },
        });
      }
      // if(item.res_type=="lesson"){   //在线课程
      //     this.$router.push({ path: '/main/learning_camp_detail', query: { tid: item.trainplan_id, rid: item.resources_id }});
      // }
      // if(item.res_type=="paper"){  //独立考试
      //     this.$router.push({ path: '/main/independent_test', query: { t_id: item.trainplan_id, r_id: item.resources_id }});
      // }
      // if(item.res_type=="face_lesson"){  //面授课程
      //     this.$router.push({ path: '/main/faceCourse', query: { tid: item.trainplan_id, rid: item.resources_id }});
      // }
      // if(item.res_type=="survey"){  //调查问卷
      //     this.$router.push({ path: '/main/survey', query: { tid: item.trainplan_id, rid: item.resources_id }});
      // }
      // if(item.res_type == "reflection"){  //反思
      //     this.superAlert("仅PC端支持");
      // }
      // if(item.res_type == "homework"){  //作业
      //     this.$router.push({ path: '/main/homework', query: { tid: item.trainplan_id, rid: item.resources_id }});

      // }
      // if(item.res_type == "case_analysis"){  //案例分析
      //     this.$router.push({ path: '/main/case', query: { tid: item.trainplan_id, rid: item.resources_id }});
      // }
      // if(item.res_type == "document"){  //拓展阅读
      //     this.$router.push({path:'/main/reading',query:{tid: item.trainplan_id, rid: item.resources_id }});
      // }
    },
  },
  filters: {
    formatData(item) {
      return {
        type: item.res_type,
        trainplan_name: item.trainplan_name,
        name: item.name,
        trainplan_type: item.trainplan_type,
      };
    },
  },
};
</script>
<style lang="less" scoped>
#dataList {
  /deep/.mescroll-empty {
    height: 90vh;
    background: #fff;
    .empty-icon {
      margin: 1rem auto 0;
    }
  }
}
</style>
